exports.bugsnagMobileApiKey = '447aa758a8fa698189888e3b9f83ff73'

exports.bugsnagTestStage = 'testing'

exports.bugsnagProductionStage = 'production'
